import { render, staticRenderFns } from "./Tivoli.vue?vue&type=template&id=5d536935&scoped=true&"
import script from "./Tivoli.vue?vue&type=script&lang=js&"
export * from "./Tivoli.vue?vue&type=script&lang=js&"
import style0 from "./Tivoli.vue?vue&type=style&index=0&id=5d536935&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d536935",
  null
  
)

export default component.exports